// extracted by mini-css-extract-plugin
module.exports = {"tabla":"orderTable_tabla__SZ10b"};